import AccountTile from "./AccountTile";
import styles from "./OrganizationRoles.module.scss";

type AccountsGridProps = {
  accounts: (API.Account | API.ExternalAccount)[];
};

export function AccountsGrid({ accounts }: AccountsGridProps) {
  return (
    <div className={styles.accountsTileGrid}>
      {accounts.map((account) => (
        <AccountTile key={account.id} account={account} />
      ))}
    </div>
  );
}

type OrgGroupedAccountsProps = {
  groupedAccounts: Map<string, API.Account[]>;
  limit?: number;
};

export function OrgGroupedAccounts({
  groupedAccounts,
  limit,
}: OrgGroupedAccountsProps) {
  let accountsToShow = groupedAccounts;

  if (limit !== undefined) {
    let totalAccountsShown = 0;
    accountsToShow = new Map();

    Array.from(groupedAccounts.entries()).forEach(
      ([orgName, orgAccounts]) => {
        if (totalAccountsShown >= limit) return;

        const remainingSlots = limit - totalAccountsShown;
        const accountsForThisOrg = orgAccounts.slice(0, remainingSlots);
        accountsToShow.set(orgName, accountsForThisOrg);
        totalAccountsShown += accountsForThisOrg.length;
      }
    );
  }

  return (
    <>
      {Array.from(accountsToShow.entries()).map(([orgName, orgAccounts]) => (
        <div key={orgName} className={styles.orgGroupContainer}>
          <span className={`${styles.orgGroupName}`}>
            {orgName}
          </span>
          {orgAccounts.length > 0 && <AccountsGrid accounts={orgAccounts} />}
        </div>
      ))}
    </>
  );
}
